import { render, staticRenderFns } from "./DailyRecruitment.vue?vue&type=template&id=545fb0c3&"
import script from "./DailyRecruitment.vue?vue&type=script&lang=js&"
export * from "./DailyRecruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports